import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=1c3587ca"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=1c3587ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports